import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import NumberUnitInput from "../../input/number-unit-input";

const NumberUnit1Widget = ({ widget, onValueUpdate }) => {
  useEffect(() => {
    return () => {};
  }, [widget]);

  const handleValueUpdate = (value, unit, max, min) => {
    console.log(value, unit, max, min);
    if (min !== null && value < min) {
      return;
    }
    if (max !== null && value > max) {
      return;
    }
    const updatedWidget = {
      ...widget,
      value: value.toString() + unit,
      unit,
      max,
      min,
    };
    onValueUpdate(updatedWidget);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
        padding: "2px",
      }}
    >
      {widget && (
        <NumberUnitInput valueSpec={widget} onChange={handleValueUpdate} />
      )}
    </Box>
  );
};

export default NumberUnit1Widget;
